import { useSelector } from "react-redux";
import useUserTier from "./useUserTier";
import { useMemo } from "react";
import { calculateOffPrice } from "../utility/helper";

const servicesKey = {
  insight: "insai",
  tradeSimulator: "trsim",
  bot: "mybot",
  aiAssistant: "myais",
  alert: "alert",
};

// pro: activate_myais_alert_mybot_insai: 165, y: 1386
// lite: activate_mybot: 25, y: 210

// service can be: insight, tradeSimulator, bot, aiAssistant, alert
function useServiceCost({
  service = "",
  isLiteSubscription = false,
  isProSubscription = false,
  duration,
}) {
  const {
    main: { userData },
    profile: { profileData, loading },
    pricingPlan: { pricingPlan, activateServiceWithCreditStatus },
  } = useSelector((state) => state);

  const offPercentage = pricingPlan["yearly_discount"];

  const { serviceType: serviceKey } = useUserTier(servicesKey[service]);

  const serviceCost = pricingPlan?.[serviceKey];

  const { serviceType: aiKey } = useUserTier("myais");
  const { serviceType: alertKey } = useUserTier("alert");
  const { serviceType: botKey } = useUserTier("mybot");
  const { serviceType: insightKey } = useUserTier("insai");
  const { serviceType: tradeSimulatorKey } = useUserTier("trsim");

  const servicesCost = useMemo(() => {
    return {
      myais: pricingPlan[aiKey],
      alert: pricingPlan[alertKey],
      mybot: pricingPlan[botKey],
      insai: pricingPlan[insightKey],
      trsim: pricingPlan[tradeSimulatorKey],
    };
  }, [aiKey, alertKey, botKey, insightKey, pricingPlan, tradeSimulatorKey]);

  const serviceList = service
    ? [serviceKey?.[service]]
    : isLiteSubscription
      ? ["mybot"]
      : isProSubscription
        ? ["myais", "alert", "mybot", "insai"]
        : [];

  const totalPrice = serviceList.reduce(
    (total, service) => total + servicesCost[service],
    0,
  );

  const finalPrice =
    duration === 1
      ? totalPrice
      : calculateOffPrice(offPercentage, totalPrice, duration, "price");
  const activationMode = `activate_${serviceList?.join("_")}`;

  return {
    servicesCost,
    totalPrice,
    finalPrice,
    serviceCost,
    activationMode,
  };
}

export default useServiceCost;
